const fetchAccountBalance = async (theapp, settings_entry, address) => {
	var card_balance = {};

	try {
		let mvcmywidget = theapp.getMvcMyWidget();
		var rootsessionuuid = await theapp.getRootSessionUUID();
		var devicewallet = await theapp.getDeviceWallet();
		var walletuuid = devicewallet.uuid;

		let context = {};
		await theapp.getCurrencyContext(context, settings_entry);

		let _currency = context.currency;
		let _scheme = context.currentscheme;

		let _card = await mvcmywidget.getCurrencyCardWithAddress(rootsessionuuid, walletuuid, _currency.uuid, address);

		// currency balance
		let _pos = await mvcmywidget.getCurrencyPosition(rootsessionuuid, walletuuid, _currency.uuid, _card.uuid).catch(err => {});
			
		if (_pos !== undefined) {
			let _card_balance_int = await _pos.toInteger();
			let _card_balance_string = await mvcmywidget.formatCurrencyAmount(rootsessionuuid, _currency.uuid, _pos);

			card_balance.balance = _card_balance_int;
			card_balance.balance_string = _card_balance_string;
		}

		// transaction units
		let _card_credit_balance = await mvcmywidget.getCardCreditBalance(rootsessionuuid, walletuuid, _card.uuid).catch(err => {});

		if (_card_credit_balance) {
			card_balance.transaction_units = _card_credit_balance.transactionunits;
		}

	}
	catch(e) {
		console.log('exception in fetchAccountPosition: ' + e);
	}

	return card_balance;
}



export {fetchAccountBalance};